module.exports = __webpack_public_path__ + "img/harrisx_harris.xpx.efc3a30.png";